<template lang="">
    <section class="flex flex-col bg-white py-4 px-4 rounded-2xl h-full">
        <h1 class="text-xl text-primary font-bold">Meus Pontos</h1>
        <p class="text-sm">Confira seu saldo de pontos</p>
        <div
            class="flex flex-col justify-center bg-gray-100 flex-grow mt-2 rounded-2xl items-center min-h-[20vh]"
        >
            <p
                class="text-3xl font-bold text-primary whitespace-nowrap"
                v-if="$page.props.auth.user.isVisibleBalance"
            >
                {{ points }} P$
            </p>
            <p
                class="text-3xl font-bold text-primary whitespace-nowrap"
                v-else
            >
                **.** P$
            </p>
            <a class="cursor-pointer" v-if="!$page.props.auth.user.isVisibleBalance" @click="handleVisibleBalance(true)" style="font-siza: 0.8rem">
                Ver saldo
            </a>

            <a class="cursor-pointer" v-else @click="handleVisibleBalance(false)" style="font-siza: 0.8rem">
                Ocultar saldo
            </a>
        </div>
        <div
            class="xl:flex items-center flex-wrap gap-y-1 justify-between pt-2"
        >
            <div class="text-sm flex flex-col justify-between text-gray-600">
                <p class="text-[10px] text-left flex items-center">
                    Última atualização:
                    {{
                        lastUpdate
                            ? formatUpdatedDate(lastUpdate)
                            : getCurrentDate()
                    }}
                </p>
                <a
                    href="/extrato-de-pontos"
                    class="flex items-center gap-x-1 whitespace-nowrap sm:py-3"
                    >Ver extrato
                    <Icon name="ArrowRight" class="translate-y-[1px]"
                /></a>
            </div>

            <a>
                <Button class="p-3" @click="openReconhece">
                    Resgate Agora
                </Button>
            </a>
        </div>
    </section>
    <ModalReconheceDisabled :showModal="isFlaggedModalOpen" @closeModal="closeIsFlaggedModal" />
    <MFAModal v-if="isAuthorizeModalOpen"
        :credentialauthenticationmethods="credential.credentialauthenticationmethods"
        accessTo="reconhece"
        :showModal="isAuthorizeModalOpen"
        @onCancel="cancelAuthorizationModalEvent"
        @onSuccess="successAuthorizationModalEvent" />
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import { formatUpdatedDate } from "@/Helpers/masks";
import moment from "moment";
import axios from "axios";
import Button from '@/Components/Button.vue';
import ModalReconheceDisabled from "@/Components/UI/Modals/ModalReconheceDisabled.vue";
import MFAModal from "@/Components/MFA/Modal.vue";

export default {
    components: {
        Icon,
        Button,
        ModalReconheceDisabled,
        MFAModal,
    },
    props: {
        points: Number,
        lastUpdate: String,
        isVisibleBalance: Number,
    },
    data() {
        return {
            isAuthorizeModalOpen: false,
            isFlaggedModalOpen: false,
        };
    },
    computed: {
        canAccessReconhece() {
            return !!!this.$page.props.auth.user.isFlagged;
        },
        urlReconhece() {
            return this.$page.props.auth.user.urlReconhece;
        },
        credential() {
            return this.$page.props.auth.user.credential;
        },
    },
    methods: {
        closeAuthorizationModal() {
            this.isAuthorizeModalOpen = false;
        },
        openAuthorizationModal() {
            this.isAuthorizeModalOpen = true;
        },
        cancelAuthorizationModalEvent() {
            this.closeAuthorizationModal();
        },
        successAuthorizationModalEvent() {
            this.closeAuthorizationModal();
            
            setTimeout(() => {
                return window.open(this.urlReconhece, '_blank');
            })
        },
        openReconhece() {
            if (this.canAccessReconhece) {
                this.openAuthorizationModal();
            } else {
                this.openIsFlaggedModal();
            }
        },
        openIsFlaggedModal() {
            this.isFlaggedModalOpen = true;
        },
        closeIsFlaggedModal() {
            this.isFlaggedModalOpen = false;
        },
        getCurrentDate: function () {
            return new moment().format("DD/MM/YYYY [às] HH:mm");
        },
        handleVisibleBalance: function (opt) {
            console.log({opt})
            axios
                .post(route("my-profile-change-visible-balance"), {
                    isVisibleBalance: opt,
                })
                .then((response) => {
                    this.$page.props.auth.user.isVisibleBalance = opt;
                });
        },
        formatUpdatedDate,
    },
};
</script>
